import { render } from "./RadarWithPolygonFill.vue?vue&type=template&id=027fc4c2"
import script from "./RadarWithPolygonFill.vue?vue&type=script&lang=js"
export * from "./RadarWithPolygonFill.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__